<script setup lang="ts">
import { computed } from 'vue'

import type { InsightFilters, InsightPlatformOption } from '../../models/insightDisplay.types'

import { useI18n } from '@/shared/i18n'
import { Input } from '@/shared/ui/input'
import { Select, type SelectOption } from '@/shared/ui/select'

const props = withDefaults(defineProps<{ platformOptions?: readonly InsightPlatformOption[] }>(), {
  platformOptions: () => [],
})
const model = defineModel<InsightFilters>({ required: true })
const { t } = useI18n()
const search = computed({
  get: () => model.value.q,
  set: (value: string | number) => update({ q: String(value) }),
})
const platform = computed({
  get: () => model.value.platform,
  set: (value: string | null) => update({ platform: value }),
})
const platformOptions = computed<SelectOption<string>[]>(() =>
  props.platformOptions.map(({ value, label }) => ({
    value,
    label,
    meta: { visual: { platform: value } },
  })),
)

function update(patch: Partial<InsightFilters>): void {
  model.value = { ...model.value, ...patch }
}
</script>

<template>
  <div
    class="insight-filters grid grid-cols-[minmax(16rem,_1fr)_minmax(11rem,_12.5rem)] items-end gap-sm max-[42rem]:grid-cols-[minmax(0,_1fr)]"
  >
    <Input
      v-model="search"
      type="search"
      :label="t('insights.filters.search')"
      :placeholder="t('insights.filters.searchPlaceholder')"
      hide-label
    />
    <Select
      v-model="platform"
      data-testid="insights-platform-filter"
      :options="platformOptions"
      :label="t('insights.filters.platform')"
      :placeholder="t('insights.filters.allPlatforms')"
    />
  </div>
</template>
